import React, { useEffect, useState } from "react";
import "./products-list.css";
import ProductModalComponent from "../Product-Modal/product-modal";
import useShoppingKartStore from "../../Stores/shoppingKartStore";
import useProductStore from "../../Stores/productStore";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import useFilterStore from "../../Stores/filterStore";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import useCotizadorStore from "../../Stores/cotizadorStore";

function ProductsListComponent() {
  const [openModal, setOpenModal] = useState(false);
  const [product, setProduct] = useState({});
  // const [productList, setProductList] = useState([]);
  const addToKart = useShoppingKartStore((state) => state.addToKart);
  const addToCotizador = useCotizadorStore((state) => state.addToCotizador);
  const productList = useProductStore((state) => state.productList);
  const setProductList = useProductStore((state) => state.replaceProducts);
  const filters = useFilterStore((state) => state.filters);
  const replaceFilters = useFilterStore((state) => state.replaceFilters);

  const closeModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = (prod) => {
    setProduct(prod);
    setOpenModal(true);
  };

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const {search} = useParams()

  useEffect(() => {
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/products")
      .then((data) => data.json())
      .then((res) => {
        setProductList([...res]);
      });
  }, []);

  const bgStyle = {
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  useEffect(() => {
    let fetchData = {
      method: "POST",
      body: JSON.stringify({ filters }),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch(
      "https://grupo-serdan-back-iplv-dev.fl0.io/api/products/getwithfilters",
      fetchData
    )
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        setProductList([...res]);
      });
  }, [filters]);

  return (
    <div className="product-list-container">
      <ProductModalComponent
        closeModal={closeModal}
        isOpen={openModal}
        product={product}
      />
      <div className="products-container">
        {productList.map((el) => (
          <div key={el.id} className="product-card-container">
            <div className="product-card-inner-container">
              <div className="product-card">
                <div
                  className="product-photo"
                  style={{
                    backgroundImage: "url(" + el.productImg + ")",
                    ...bgStyle,
                  }}
                ></div>
                <div className="product-text">
                  <p className="product-header">
                    <b>{el.name}</b>
                  </p>
                  <span className="product-price">
                    {formatter.format(Number(el.price))}
                  </span>{" "}
                  {el?.tag
                    ?.filter((el) => el.tagType === "marca")
                    .map((brand) => (
                      <span
                        style={{ color: "red", marginTop: "10px" }}
                        key={brand.id}
                      >
                        <b>Marca: </b> {brand.tagName}
                      </span>
                    ))}
                  <br />
                  {/* <span onClick={() => addToKart(el)}>Añadir al carrito</span> */}
                  <div className="a-tag-container">
                    <Button
                      onClick={() => handleOpenModal(el)}
                      variant="contained"
                      color="success"
                      style={{
                        marginTop: "auto",
                        width: "fit-content",
                      }}
                    >
                      Ver ficha técnica
                    </Button>
                    <Button
                      onClick={() => addToCotizador(el)}
                      variant="contained"
                      color="primary"
                      style={{
                        marginTop: "auto",
                        width: "fit-content",
                        marginLeft: "10px",
                      }}
                    >
                      Añadir a Cotización
                    </Button>
                    <Button
                      onClick={() => addToKart(el)}
                      variant="contained"
                      color="error"
                      style={{
                        marginTop: "auto",
                        width: "fit-content",
                        marginLeft: "10px",
                      }}
                    >
                      Añadir al carrito{" "}
                      <FontAwesomeIcon
                        icon={faShoppingCart}
                        style={{
                          color: "#FFFFFF",
                          marginLeft: "8px",
                          transform: "scale(1.1)",
                        }}
                      />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductsListComponent;
